import request from '@/common/js/request.js'

// 获取分销课程列表
export function selectCourseDistributions(obj) {
    return request({
        url: '/course/selectCourseDistribution',
        method: 'get',
        params: obj
    })
}

// 用户分销佣金
export function selectCountPrice() {
    return request({
        url: '/userCourseDistribution/selectOwnDistributionTotalPrice',
        method: 'get'
    })
}

// 推广统计
export function selectCourseDistributionInfos(obj) {
    return request({
        url: '/userCourseDistribution/selectCourseDistributionInfos',
        method: 'get',
        params: obj
    })
}

// 推广统计明细
export function selectCourseDistributionDetails(obj) {
    return request({
        url: '/userCourseDistribution/selectCourseDistributionDetails',
        method: 'get',
        params: obj
    })
}


// WEBPACK FOOTER //
// ./src/api/promote.js